export default __webpack_public_path__ + "images/roof-access.97a181a3b925e7ac96e083b6973cebb0.png";